import { SpotlightPanel } from './SpotlightPanel';
import { StickyMediaRail } from './StickyMediaRail';
import type { ProductSpotlightConfig } from './types';
import styles from './ProductSpotlight.module.css';

type ProductSpotlightProps = {
  product: ProductSpotlightConfig;
  labelledBy: string;
};

export const ProductSpotlight = ({
  product,
  labelledBy,
}: ProductSpotlightProps) => (
  <article className={styles.root} aria-labelledby={labelledBy}>
    <div className={styles.layout}>
      <div className={styles.railSlot}>
        <StickyMediaRail
          product={product}
          nameId={`form-factor-${product.id}-name`}
        />
      </div>

      <div className={styles.panels}>
        {product.panels.map((panel, index) => (
          <SpotlightPanel
            key={`${product.id}-panel-${panel.type}-${index}`}
            panel={panel}
            theme={product.theme}
          />
        ))}
      </div>
    </div>
  </article>
);
